import React, {useState, useEffect} from "react";
import MenuItem from "./MenuItem";
import useBreakpoint from "Hooks/useBreakpoint";
import {useGlobal} from "reactn";
import Cookies from "js-cookie";

import {
    MainMenuWrapper,
    Logo,
    MainMenuContent,
    MainMenuBottom,
    MainMenuTop,
    Placeholder,
    ButtonWrapper,
} from "./MenuComponents";
import {useSelector} from "react-redux";
import {SearchField} from "Components/SearchField";
import {LoginButton} from "./LoginButton";

export const MainMenu = (MainMenu) => {
    const {
        MenuLogo,
        MenuItems: {IsActive, Name, Url, Icon, Children},
        SearchPage,
        ProfilePage,
        currentUser,
        SearchText
    } = MainMenu;
    const startPage = {IsActive, Name, Url, Icon};
    const {FirstName} = currentUser;
    const [theme] = useGlobal("theme");

    const state = useSelector(({mobileMenu}) => mobileMenu);
    const [open, toggle] = useState(state.show);

    useEffect(() => {
        toggle(state.show);
        state.show
            ? document.body.classList.add("no-scroll")
            : document.body.classList.remove("no-scroll");
    }, [state]);

    let isADUser = Cookies.get("AdUser");
    let depth = 1;
    return (
        <>
            <Placeholder>
                <MainMenuWrapper open={open}>
                    <MainMenuTop>
                        {!useBreakpoint("ipad", 'down') && <Logo Src={MenuLogo}/>}
                        <SearchField SearchUrl={SearchPage} SearchText={SearchText}/>
                    </MainMenuTop>
                    <MainMenuContent>
                        <MenuItem Depth={1} {...startPage} Display={open}/>
                        {Children.map((page, i) => {
                            let lastItem = Children.length - 1 == i;
                            return (
                                <MenuItem
                                    Depth={depth}
                                    {...page}
                                    Display={open}
                                    key={i}
                                    LastItem={lastItem}
                                />
                            );
                        })}

                        <MainMenuBottom>
                            <ButtonWrapper>
                                {isADUser && (
                                    <LoginButton {...{ProfilePage, theme, FirstName}} />
                                )}
                            </ButtonWrapper>
                        </MainMenuBottom>
                    </MainMenuContent>
                </MainMenuWrapper>
            </Placeholder>
        </>
    );
};
